export default __webpack_public_path__ + "static/Profilepic 1-4f2b5e96666a61c7b4fc42739fd3c5c5.svg";